import {
    BarChartOutlined, BookOutlined, DoubleLeftOutlined, DoubleRightOutlined, InfoCircleOutlined, LogoutOutlined,
    ProfileOutlined, SettingOutlined, ShareAltOutlined, SyncOutlined, TeamOutlined, DatabaseOutlined
} from '@ant-design/icons';
import { Affix, Button, Col, Input, Layout, Menu, Modal, Row, Spin } from 'antd';
import 'antd/dist/antd.css';
import React, { Component } from "react";
import cookie from "react-cookies";
import { connect } from "react-redux";
import { Link, Redirect } from 'react-router-dom';
import { closeDrawer, openDrawer } from "../action/dashboard.action";
import { logout } from "../action/login.action";
import { checkSessionValidity } from "../action/common.action";
import logo_full from "../asset/img/logo-mp.png";
import logo_square from "../asset/img/logo_square.png";
import "../asset/style/morpheus.css";
import ScannersListComp from "../component/dashboard/scannerspane";
import ClassifierUI from '../component/viewer/classifierView';
import { urls } from "../helper/backend.urls";
import { historyMP } from '../helper/history';
import { PrivateRoute } from '../helper/private.route';
import { globalUrlPrefix } from '../utils/const';
import AddCaseView from '../view/addcase';
import CaseListView from '../view/caselist';
import CasesView from '../view/casesview';
import { CaseView } from '../view/caseview';
import CategoryView from '../view/category';
import OldScan from '../view/oldscan';
import ScannerView from '../view/scanner';
import SingleCaseView from '../view/singlecaseview';
import { SyncViewerView } from '../view/sync-viewer';
import AddUserView from './adduser';
import AllScansView from "./dashboard";
import EditUserView from './edituser';
import ManageUsers from './manageusers';
import Disks from "./Disks";
import GeneralSettingsView from "./export_settings";
import SettingsView from './settings';
import SlideTimeStatistics from './slideTimeStatisticsView';
import StatsDashboard from './statsDashboard';
import { TuningView } from './tuning';
import ScanWorkflowNew from '../component/scanner/scan_workflow_new';
import LivePlot from './liveplot';
import C240ControlPanelView from './loader/c240_control_panel_view';

const { SubMenu } = Menu;
const { Sider, Content } = Layout;


export class Morpheus extends Component {
    
    constructor(props) {
        super(props);
        
        this.isMobile= cookie.load('isMobile') === 'true';

        this.state = {
            collapsed: this.isMobile ? true : false,
            sessionValid: true
          };
    }

    componentDidMount = () => {
        // var interval = 10000;  // in milliseconds
        // var intervalId = setInterval(this.checkSessionValidity, interval);
        // this.sessionCheckIntervalId = intervalId;
    };

    componentWillUnmount = () => {
        // clearInterval(this.sessionCheckIntervalId);
    };

    checkSessionValidity = () => {
        this.props.dispatch(checkSessionValidity(this.onSessionValidityResponse));
    };

    onSessionValidityResponse = (isValid) => {
        console.log("Session validity response", isValid);
        this.setState({sessionValid: isValid});
        if(!this.state.sessionValid) {
            let message = "We logged you out because you signed in somewhere else."
            let resolution = "Please Contact Administrator if you did not sign-in elsewhere";
            this.logout(message, resolution);
        }
    };

    toggle = () => {
        if (this.props.drawerCollapsed) {
            this.props.dispatch(openDrawer());
        } else {
            this.props.dispatch(closeDrawer());
        }
    };

    onCollapse = collapsed => {
        if (collapsed) {
            this.props.dispatch(closeDrawer());
        } else {
            this.props.dispatch(openDrawer());
        }
    };

    logout = (displayMessage = null, resolution = null) => {
        this.props.dispatch(logout(displayMessage, resolution));
    };

    goToAdminMode = () => {
        window.location.href =
          urls.current + "/admin";
    }

    render(){
        let selectedItem = [];
        let urlParts = window.location.href.split('/');
        let component = urlParts[4].split('?')[0];
        if(component === 'scanners') {
            component = "scanner-" + urlParts[5];
        } else if(component === 'sync') {
            component = '3';
        } else if(component === 'categories') {
            component = '9';
        } else if(component === 'manageusers') {
            component = '4';
        } else if(component === 'adduser') {
            component = '4';
        } else if(component === 'edituser') {
            component = '4';
        } else if(component === 'case') {
            component = 'cases';
        }
        selectedItem.push(component);
        let sideMenuContent = getSideMenu(this.props.drawerCollapsed, this.toggle, this.logout, this.goToAdminMode, selectedItem);
        let sideMenu = null;
        let mobileHeader = null;

        if (this.isMobile) {
            mobileHeader = <Row className="mobile-header">
                <Col span={24}>
                    <img className="logo-mobile" src={logo_full} onClick={() => historyMP.push('/' + globalUrlPrefix + '/dashboard')}/>
                    <Row className="login-user-row">
                        <span className="login-user-prefix">Logged in as </span>
                            <br></br>
                        <span className="login-user">{cookie.load('first_name')}</span>
                        <br></br>
                        <Button key="7" onClick={this.logout}>
                            <LogoutOutlined />
                            <span>Logout</span>
                        </Button>
                    </Row>
                </Col>
            </Row>
        } else {
            sideMenu = <Sider className="sider" collapsed={this.props.drawerCollapsed} onCollapse={this.onCollapse}>
                {sideMenuContent}
            </Sider>
        }
        return(
            <Spin spinning={this.props.uiBusy} tip={this.props.busyMessage}>
                <Layout id="outer-container">
                    {sideMenu}
                    <Layout className="main-content">
                    {mobileHeader}
                    <Content id="content">
                        <PrivateRoute path={"/" + globalUrlPrefix + "/dashboard"} component={AllScansView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/scannerflow/:id/scan/:stage"} component={ScanWorkflowNew} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/scanners/:id/:progress_stage?"} component={ScannerView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/tuning/:id/"} component={TuningView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/sync/"} component={SyncViewerView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/case-edit/:id"} component={CaseView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/categories/"} component={CategoryView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/category/:id/"} component={CaseListView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/classifier/:id/:spectype/:subtype/"} component={ClassifierUI} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/tuning/:id/"} component={TuningView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/oldviewer/:id/"} component={OldScan} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/cases"} component={CasesView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/case/:id/"} component={SingleCaseView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/addcase/"} component={AddCaseView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/manageusers/"} component={ManageUsers} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/adduser/"} component={AddUserView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/edituser/:id/"} component={EditUserView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/settings/:id/"} component={SettingsView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/slidestatistics"} component={SlideTimeStatistics} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/c240_control_panel/:id"} component={C240ControlPanelView} />
                        {/* <PrivateRoute path={"/" + globalUrlPrefix + "/export_settings"} component={GeneralSettingsView}/> */}
                        <PrivateRoute path={"/" + globalUrlPrefix + "/stats"} component={StatsDashboard} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/live_plot/:path/"} component={LivePlot} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/disks"} component={Disks}/>
                    </Content>
                    </Layout>
                </Layout>
            </Spin>
        )
    }
}

function getSideMenu(collapsed, toggleHandler, logout, goToAdminMode, selectedItem) {
    let adminComponent = (cookie.load('morpheus_setting') || {}).show_case_view ? 
        [<Menu.Item key="9">
            <Link to={'/' + globalUrlPrefix + '/categories'}>
                <BookOutlined />
                <span>Cases</span>
            </Link>
        </Menu.Item>] : [];

    let deploymentMode = cookie.loadAll().deployment_mode;
    let is_audience = (cookie.load('morpheus_setting') || {}).is_audience;
    let show_scanner = (cookie.load('morpheus_setting') || {}).show_scanner;
    let offlineComponent =  (cookie.loadAll().deployment_mode === 'offline' && !((cookie.load('morpheus_setting') || {}).is_audience)) ? 
        [
            (cookie.load('morpheus_setting') || {}).show_scanner ? <ScannersListComp key={0}/> : undefined , ...adminComponent
        ] : undefined;

    let askForSyncCode = () => {
        Modal.confirm({
          title: 'Please enter the code shared by the presenter',
          icon: <InfoCircleOutlined></InfoCircleOutlined>,
          content: (
              <Input placeholder="Enter code here" id="sync-code" />
          ),
          onOk() {
            var code = document.getElementById("sync-code").value;
            var slideId = code.split('-')[0];
            var syncCode = code.split('-')[1];
            historyMP.push('/' + globalUrlPrefix + '/viewer/' + slideId + '?presentCode=' + syncCode);
          },
          onCancel() {}
        });
    }

    return (
        <Affix>
        <Row>
            {collapsed ? <img className="logo-square" src={logo_square} onClick={() => {
                if(cookie.loadAll().is_staff === 'true' || cookie.loadAll().superuser === 'true' || 
                    cookie.loadAll().show_all_slides === 'true' || (cookie.load('morpheus_setting') || {}).is_audience) {
                    historyMP.push('/' + globalUrlPrefix + '/dashboard');
                } else {
                    historyMP.push('/' + globalUrlPrefix + '/cases');
                }
            }}/> :
            <img className="logo" src={logo_full} onClick={() => {
                if(cookie.loadAll().is_staff === 'true' || cookie.loadAll().superuser === 'true' || 
                    cookie.loadAll().show_all_slides === 'true' || (cookie.load('morpheus_setting') || {}).is_audience) {
                    historyMP.push('/' + globalUrlPrefix + '/dashboard');
                } else {
                    historyMP.push('/' + globalUrlPrefix + '/cases');
                }
            }}/>}
        </Row>
        <Row className="login-user-row">
            <span className="login-user-prefix">Logged in as </span>
                <br></br>
            <span className="login-user">{cookie.load('first_name')}</span>
        </Row>
        <Row>
            <Menu 
                mode="inline" 
                defaultOpenKeys={['scanners']}
                defaultSelectedKeys={['dashboard']}
                selectedKeys={selectedItem}
                className={"side-menu " + (collapsed ? '': 'side-menu-border')}>
                <Menu.Item key="0" onClick={toggleHandler}>
                <b> {collapsed ? <DoubleRightOutlined/> : <DoubleLeftOutlined/> }
                    <span>{collapsed ? "Open Menu" : "Collapse Menu"}</span></b>
                </Menu.Item>
                {cookie.loadAll().is_staff === 'true' || cookie.loadAll().superuser === 'true' || cookie.loadAll().show_all_slides === 'true' || (cookie.load('morpheus_setting') || {}).is_audience ?
                <Menu.Item key="dashboard">
                    <Link to={'/' + globalUrlPrefix + '/dashboard'}>
                        <ProfileOutlined />
                        <span>All Scans</span>
                    </Link>
                </Menu.Item> : undefined }
                {cookie.loadAll().is_staff === 'true' || cookie.loadAll().superuser === 'true' || (!(cookie.load('morpheus_setting') || {}).is_audience && cookie.loadAll().show_case_view === 'true') ?
                    <Menu.Item key="cases">
                        <Link to={'/' + globalUrlPrefix + '/cases'}>
                            <BookOutlined />
                            <span>Cases</span>
                        </Link>
                    </Menu.Item> : undefined }
                {cookie.loadAll().is_staff === 'true' ?
                    <Menu.Item key="stats">
                        <Link to={'/' + globalUrlPrefix + '/stats'}>
                            <BarChartOutlined />
                            <span>Stats Dashboard</span>
                        </Link>
                    </Menu.Item> : undefined }
                {cookie.loadAll().superuser === 'true' ?
                    <Menu.Item key="slidestatistics">
                        <Link to={'/' + globalUrlPrefix + '/slidestatistics'}>
                            <BarChartOutlined />
                            <span>Slide Statistics</span>
                        </Link>
                    </Menu.Item> : undefined }
                {offlineComponent}
                {cookie.load('first_name') === "Web Demo" || ((cookie.load('morpheus_setting') || {}).is_audience) ? undefined :
                     [ //<Menu.Item key="3">
                    //     <Link to={'/' + globalUrlPrefix + '/sync'}>
                    //         <SyncOutlined />
                    //         <span>Sync Mode</span>
                    //     </Link>
                    // </Menu.Item>, 
                    <Menu.Item key="8" onClick={askForSyncCode}>
                        <ShareAltOutlined />
                        <span>Join Slide Share</span>
                    </Menu.Item> ]}
                {(cookie.loadAll().is_staff === 'true' || cookie.loadAll().superuser === 'true')  ?
                <Menu.Item key="diskinfo">
                    <Link to={'/' + globalUrlPrefix + '/disks'}>
                        <DatabaseOutlined/>
                        <span>Disks Info</span>
                    </Link>
                </Menu.Item> : undefined }
                {/* {(cookie.loadAll().is_staff === 'true' || cookie.loadAll().superuser === 'true')  ? 
                // <Menu.Item key="10">
                //     <Link to={'/' + globalUrlPrefix + '/export_settings'}>
                //         <SettingOutlined/>
                //         <span>Export Settings</span>
                //     </Link>
        // </Menu.Item> : undefined */ }
                {(cookie.load('morpheus_setting') || {}).show_admin_mode ?
                <Menu.Item key="4">
                    <Link to={'/' + globalUrlPrefix + '/manageusers'}>
                        <TeamOutlined />
                        <span>Manage Users</span>
                    </Link>
                </Menu.Item> : undefined }
                {cookie.loadAll().superuser === 'true' ?
                <Menu.Item key="5" onClick={goToAdminMode}>
                    <SettingOutlined />
                    <span>Admin Mode</span>
                </Menu.Item> : undefined  }
                {!((cookie.load('morpheus_setting') || {}).is_audience) ?
                <Menu.Item key="7" onClick={logout}>
                    <LogoutOutlined />
                    <span>Logout</span>
                </Menu.Item> : undefined }
            </Menu>
        </Row>
        </Affix>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        drawerCollapsed: state.dashboardReducer.drawerCollapsed, 
        uiBusy: state.utilsReducer.uiBusy, 
        busyMessage: state.utilsReducer.busyMessage,
        popupProps: state.contextMenuReducer.popupProps
    };
};

export default connect(mapStateToProps)(Morpheus);
